// Format date for API calls
export const formatDateForAPI = (date, time = "0000") => {
  const d = new Date(date);
  return `${String(d.getDate()).padStart(2, "0")}${String(d.getMonth() + 1).padStart(2, "0")}${d.getFullYear()}${time}`;
};

// Format duration in seconds to readable format
export const formatDuration = (seconds) => {
  if (!seconds) return "0s";
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return mins === 0 ? `${secs}s` : `${mins}dk ${secs}s`;
};

// Format talk time for reports
export const formatTalkTime = (seconds) => {
  if (!seconds || seconds === 0) return "0 dk";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours > 0) {
    return `${hours} saat ${minutes} dk`;
  }
  return `${minutes} dk`;
};

/** Mola analizi — çağrı arası + mesai sonu (≥5 dk erken çıkış) */
export const MOLA_MIN_SECONDS = 300;

export const isMolaBreak = (breakRow) => {
  if (!breakRow) return false;
  if (breakRow.type === "between_calls") return true;
  if (breakRow.type === "early_leave") {
    return (Number(breakRow.duration_seconds) || 0) >= MOLA_MIN_SECONDS;
  }
  return false;
};

// Format total duration for summary stats
export const formatTotalDuration = (seconds) => {
  if (!seconds) return "0dk";
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  if (hours > 0) return `${hours}sa ${mins}dk`;
  return `${mins}dk`;
};

// Date helpers (yerel takvim — toISOString UTC kayması yapmaz)
export const formatLocalDateStr = (dt) => {
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const dd = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
};

export const getTodayStr = () => formatLocalDateStr(new Date());

export const getYesterdayStr = () => {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return formatLocalDateStr(d);
};

export const getLast7DaysStr = () => {
  const d = new Date();
  d.setDate(d.getDate() - 7);
  return formatLocalDateStr(d);
};

export const getThisMonthStart = () => formatLocalDateStr(new Date(new Date().getFullYear(), new Date().getMonth(), 1));

/** Bu takvim ayı: ayın 1’i — bugün (yerel) */
export const getThisMonthRange = () => ({
  start: getThisMonthStart(),
  end: getTodayStr(),
});

/** Bir önceki takvim ayının ilk ve son günü (yerel) */
export const getLastMonthRange = () => {
  const d = new Date();
  const start = new Date(d.getFullYear(), d.getMonth() - 1, 1);
  const end = new Date(d.getFullYear(), d.getMonth(), 0);
  return { start: formatLocalDateStr(start), end: formatLocalDateStr(end) };
};

/** Önceki takvim haftası (Pazartesi–Pazar), yerel tarih */
export const getLastWeekRange = () => {
  const today = new Date();
  const day = today.getDay() || 7;
  const thisMonday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  thisMonday.setDate(thisMonday.getDate() - (day - 1));
  const lastMonday = new Date(thisMonday);
  lastMonday.setDate(lastMonday.getDate() - 7);
  const lastSunday = new Date(lastMonday);
  lastSunday.setDate(lastSunday.getDate() + 6);
  const fmt = (dt) => {
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const dd = String(dt.getDate()).padStart(2, "0");
    return `${y}-${m}-${dd}`;
  };
  return { start: fmt(lastMonday), end: fmt(lastSunday) };
};

// Generate password (A-Z, a-z, 0-9)
export const generateRandomPassword = (length = 8) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let password = '';
  for (let i = 0; i < length; i++) {
    password += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return password;
};

// Convert Turkish characters to ASCII for username
export const generateUsername = (name) => {
  if (!name) return "";
  const turkishMap = {
    'ç': 'c', 'Ç': 'c', 'ğ': 'g', 'Ğ': 'g', 'ı': 'i', 'İ': 'i',
    'ö': 'o', 'Ö': 'o', 'ş': 's', 'Ş': 's', 'ü': 'u', 'Ü': 'u'
  };
  return name
    .split('')
    .map(char => turkishMap[char] || char)
    .join('')
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/[^a-z0-9]/g, '');
};
